module.exports = __webpack_public_path__ + "assets/img/00107.76a51303.png";